import React, { Component } from 'react';
import LoginForm from '../../Login/LoginForm';
import { AppContext } from '../../../context/AppProvider';
import tropicalLogo from '../../../assets/images/tropical-logo.png';
import {withRouter} from "./withRouter";

class LoginPage extends Component {
    static contextType = AppContext;

    redirect = async () => {
        const from = this.props.location.state?.from
            ? this.props.location.state.from?.pathname
            : '/';
        await this.props.navigate(from);
    };

    render() {
        return (
            <section className="section">
                <div className="container mt-3">
                    <div className="columns is-centered">
                        <div className="column is-one-third is-offset-one-third">
                            <figure className="image">
                                <img src={tropicalLogo} width="300"
                                     height="auto" alt="Tropical Casting" />
                            </figure>
                        </div>
                    </div>

                    <div className="columns is-centered">
                        <div className="column is-one-third">
                            <LoginForm onSuccess={this.redirect} />
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default withRouter(LoginPage);